import React, { useEffect } from "react";

import * as Sentry from "@sentry/nextjs";

import Heading from "../heading";
import styles from "./index.module.css";

interface TermlyEmbedProps {
  id: string;
  title?: string;
}

const TermlyEmbed = ({ title, id }: TermlyEmbedProps) => {
  const srcUrl = `https://app.termly.io/policy-viewer/iframe-content.html?policyUUID=${id}`;

  useEffect(() => {
    // Log to sentry if the embed src fails to load
    fetch(srcUrl).catch(function (error) {
      Sentry.captureException(new Error(`There was an error loading the Termly policy iframe: ${srcUrl}`));
    });
  }, [srcUrl, id]);

  return (
    <>
      <div className={styles.content}>
        <div className={styles.card}>
          <div className={styles.cardHeader}>
            {!!title && (
              <Heading tag="h3" size="h6" fontWeight="regular" className="text-gray-800">
                {title}
              </Heading>
            )}
          </div>

          <iframe title={title} src={srcUrl} className="w-full h-screen" allowFullScreen />
        </div>
      </div>
    </>
  );
};

export default TermlyEmbed;
